import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromDataProviderSelectors from '../../store/selectors/data-provider.selectors';

@Injectable({
  providedIn: 'root'
})
export class DataProviderAuthenticatedGuard {
  private store = inject(Store);
  private router = inject(Router);

  isAuthenticated = false;
  constructor() {
    this.store.pipe(select(fromDataProviderSelectors.selectIsAuthenticated)).subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAuthenticated ? true : this.router.createUrlTree(['onboarding', 'login']);
  }
}
